/* @flow */
import * as React from 'react';

import AuthenticationView from 'auth/components/AuthenticationView';
import ShareRemind from 'user/components/ShareRemind';
import ToastActions from 'actions/ToastActions';

class ShareRemindPage extends React.Component<$FlowFixMeProps> {
  componentDidMount() {
    ToastActions.showSuccessToast('Log out successful');
  }

  render() {
    return (
      <AuthenticationView {...this.props} className="ShareRemindPage">
        <div className="ShareRemindPage-share">
          <ShareRemind />
        </div>
      </AuthenticationView>
    );
  }
}

export default ShareRemindPage;
